import React from "react";
import { Route, Routes } from "react-router-dom";
import Top from "./components/top/Top";
import Announcements from "./components/announcements/Announcements";
import AnnouncementItem from "./components/announcements/AnnouncementItem";
import NewAuction from "./components/main/newAuction/NewAuction";
import SignIn from "./components/sign in/SignIn";
import Register from "./components/sign in/Register";
import ErrorPage from "./components/ErrorPage";
import Users from "./components/users/Users";
import AddRole from "./components/admin/AddRole";
import AdminDashboard from "./components/dashboard/AdminDashboard";
import UsersDashboard from "./components/dashboard/UsersDashboard";
import AuctionsDashboard from "./components/dashboard/AuctionsDashboard";
import ConfirmEmail from "./components/sign in/ConfirmEmail";
import ConfirmPhone from "./components/sign in/ConfirmPhone";
import ForgotPassword from "./components/sign in/ForgotPassword";
import ResetPassword from "./components/sign in/ResetPassword";
import PublicOnlyRoute from "./PublicOnlyRoute";
import PrivacyPolicy from "./components/main/newAuction/PrivacyPolicy";
import Contact from "./components/main/newAuction/Contact";
import TermsAndConditions from "./components/main/newAuction/TermsAndConditions";
import FAQ from "./components/main/newAuction/FAQ";
import PrivateAdminRoute from "./PrivateAdminRoute";
import AdminDeposits from "./components/dashboard/AdminDeposits";
import ComplaintDetailsDashboard from "./components/dashboard/ComplaintDetailsDashboard";
import SendNotificationDashboard from "./components/dashboard/SendNotificationDashboard";
import ComplaintListDashboard from "./components/dashboard/ComplaintListDashboard ";

// New Cabinet Components
import CabinetLayout from "./components/cabinet/CabinetLayout";
import CabinetAnnouncements from "./components/cabinet/CabinetAnnouncements";
import CabinetBids from "./components/cabinet/CabinetBids";
import CabinetNotifications from "./components/cabinet/CabinetNotifications";
import UserSettings from "./components/cabinet/UserSettings";
import PaymentForm from "./components/cabinet/PaymentForm";

function Routing() {
  return (
    <Routes>
      {/* Public Routes with Top Layout */}
      <Route path="/" element={<Top />}>
        <Route index element={<Announcements />} />
        <Route path="elanlar/:kateqoriya" element={<Announcements />} />
        <Route path="elanlar/:kateqoriya/:alt-kateqoriya" element={<Announcements />} />
        <Route path="elanlar/:kateqoriya/:alt-kateqoriya/:id" element={<AnnouncementItem />} />
        <Route path="/yeni-herrac" element={<NewAuction />} />
        <Route path="/istifadeci/:userId" element={<Users />} />
        <Route path="/xeta" element={<ErrorPage />} />
        <Route path="/mexfilik-siyaseti" element={<PrivacyPolicy />} />
        <Route path="/elaqe" element={<Contact />} />
        <Route path="/istifade-sertleri" element={<TermsAndConditions />} />
        <Route path="/tez-tez-verilen-suallar" element={<FAQ />} />
        {/* Cabinet Routes with New Layout */}
        <Route path="/kabinetim" element={<CabinetLayout />}>
          <Route index element={<CabinetAnnouncements />} />
          <Route path="herraclarim" element={<CabinetAnnouncements />} />
          <Route path="tekliflerim" element={<CabinetBids />} />
          <Route path="bildirislerim" element={<CabinetNotifications />} />
          <Route path="ayarlar" element={<UserSettings />} />
          <Route path="balans" element={<PaymentForm />} />
        </Route>
      </Route>



      {/* Auth Routes */}
      <Route path="/giris" element={
        <PublicOnlyRoute>
          <SignIn />
        </PublicOnlyRoute>
      } />

      <Route path="/qeydiyyat" element={
        <PublicOnlyRoute>
          <Register />
        </PublicOnlyRoute>
      } />

      <Route path="/sifreni-unutdum" element={
        <PublicOnlyRoute>
          <ForgotPassword />
        </PublicOnlyRoute>
      } />

      <Route path="/sifreni-yenile" element={
        <PublicOnlyRoute>
          <ResetPassword />
        </PublicOnlyRoute>
      } />

      <Route path="/telefon-tesdiqi" element={<ConfirmPhone />} />

      {/* Admin Routes */}
      <Route path="/addrole" element={<AddRole />} />

      <Route element={<PrivateAdminRoute />}>
        <Route path="/dashboard" element={<AdminDashboard />}>
          <Route path="users" element={<UsersDashboard />} />
          <Route path="auctions" element={<AuctionsDashboard />} />
          <Route path="deposit-stats" element={<AdminDeposits />} />
          <Route path="complaint-details" element={<ComplaintDetailsDashboard />} />
          <Route path="complaint-list" element={<ComplaintListDashboard />} />
          <Route path="send-notification" element={<SendNotificationDashboard />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Routing;